import Page404 from "app/not-found";
import "../../styles/styles.css"
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PageAdmin = () => {
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.user);

    const profil = () => navigate("profil");
    const gestionUsagers = () => navigate("gestionUsagers");
    const ajouterArticle = () => navigate("ajouterArticle");
    const modifierArticle = () => navigate("modifierArticle");
    const ajouterInfolettre = () => navigate("ajouterInfolettre");
    const ajouterVideo = () => navigate("ajouterVideo");
    const ajouterEvenement = () => navigate("/ajouterEvenement"); // 🆕
    const supprimerEvenement = () => navigate("/supprimerEvenement"); // 🆕

    if (!user) return <Page404 />;

    return (
        <>
            Role: {user.role}
            <div className="container">
                <h2 className="inline-block align-middle text-2xl font-semibold md:text-3xl">
                    Administration
                </h2>
                <br /><br />
                <div>
                    <button className="boutonDownload" onClick={profil}>Profil</button>
                </div>
                <br />

                {user.role === "admin" && (
                    <>
                        <div>
                            <button className="boutonDownload" onClick={gestionUsagers}>Gestion usagers</button>
                        </div>
                        <br />
                    </>
                )}

                {(user.role === "admin" || user.role === "editor") && (
                    <>
                        <div>
                            <button className="boutonDownload" onClick={ajouterArticle}>Ajouter Article</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={modifierArticle}>Modifier Article</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={ajouterInfolettre}>Ajouter Infolettre</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={ajouterVideo}>Ajouter Vidéo</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={ajouterEvenement}>Ajouter Événement</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={supprimerEvenement}>Supprimer Événement</button>
                        </div>
                    </>
                )}
                <br /><br />
            </div>
        </>
    );
};

export default PageAdmin;
